export default __webpack_public_path__ + "static/media/header-container-pink.5b28451f.png";